<script setup lang="ts">
defineOptions({
  name: 'MopNotFound',
  layout: 'default',
});

const props = defineProps({
  error: {
    type: Object,
    default: null,
  },
});

const { $storyblokLivePreview, $gtm, $mopI18n, $urls } = useNuxtApp();
const { getCmsStory, cmsStoryModelRef } = useMopCms();
const { getHeadObject } = useMopSeo();

onMounted(async () => {
  await getCmsStory(constants.STORYBLOK.STORY_PATHS.ERROR_PAGE);
  $gtm.trackPageView({
    pageType: 'PageNotFound',
    errorCode: props.error?.statusCode?.toString(),
  });
});

function handleSearchSubmit(searchTerm: string) {
  useRouter().push({
    path: $mopI18n.localePath($urls.SEARCH),
    query: {
      q: searchTerm,
    },
  });
}

$storyblokLivePreview.initStoryListener('Storyblok', cmsStoryModelRef);

useHead(
  getHeadObject({
    title: $mopI18n.t('locale.meta.title_not_found'),
    description: $mopI18n.t('locale.meta.title_not_found'),
    isIndexable: false,
  }) as any,
);
</script>

<template>
  <div class="error-page">
    <div class="transition-content">
      <div class="error-page__search-wrap">
        <MopCmsContentElementsSlot
          id="error-page__message"
          class="error-page__message"
          :elements="cmsStoryModelRef.getContentElements('bodyTop')"
          no-padding
        />
        <div class="error-page__search">
          <h2 class="error-page__search-title">
            {{ $mopI18n.t('locale.error.not_found.search_title') }}
          </h2>
          <MopSearchForm @submit="handleSearchSubmit" />
        </div>
      </div>

      <MopCmsContentElementsSlot
        id="error-page__bottom-content"
        :elements="cmsStoryModelRef.getContentElements('bodyBottom')"
        lazy-load
        no-padding
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error-page__search-wrap {
  display: flex;
  flex-wrap: wrap;
  margin: 0 $global-padding $space50;
}

:deep() {
  .ui-cms-headline__headline {
    @include text-style(headline);

    margin-bottom: $space20;

    @include apply-upto(medium) {
      margin-top: 0;
    }

    @include apply-from(medium) {
      margin-bottom: $space30;
      margin-top: 0;
    }
  }
}

.error-page__message {
  @include text-style(running);

  color: $brand;

  @include apply-upto(medium) {
    margin-bottom: $space20;
  }

  @include apply-from(large) {
    margin-bottom: $space30;
  }
}

.error-page__search {
  width: 100%;

  @include apply-upto(medium) {
    margin-top: $space20;
  }

  @include apply-from(large) {
    margin-top: $space30;
  }
}

.error-page__search-title {
  @include text-style(headline-2);

  display: inline-block;
}
</style>
